// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SellerReviews__selfBlocked":"gu_a bhi_ea bhi_uy bhi_tq bhi_vk bhi_vf"};